import { MfaStatusMessageType } from '../InputOTP/StatusMessage/status-message.enum';

import { VerificationStatus } from './verification-status.enum';

export const getStatusMessage = (
  status: VerificationStatus,
  attemptsUsed: number,
  maxAttempts: number
): string | undefined => {
  if (status === VerificationStatus.SUCCESS) return 'Verification complete!...';
  if (status === VerificationStatus.ERROR) return 'Invalid code, try again...';
  if (attemptsUsed >= 0 && maxAttempts > 0) {
    return `Attempts ${attemptsUsed + 1} of ${maxAttempts}`;
  }
  return undefined;
};

export const getMessageType = (
  status: VerificationStatus
): MfaStatusMessageType => {
  if (status === VerificationStatus.SUCCESS)
    return MfaStatusMessageType.SUCCESS;
  if (status === VerificationStatus.ERROR) return MfaStatusMessageType.ERROR;
  return MfaStatusMessageType.INFO;
};
